<template>
  <div class="renewal_standard">
    <div class="header_whole">
      <div class="title">
        <span>{{ t('home.renewalTitle') }}</span>
        <span>(2024-04-23)</span>
      </div>
      <div class="view_more" @click="viewMore">{{ t('home.viewMore') }}</div>
    </div>
    <div class="swiper_content">
      <!-- <ElBlockSkeleton height="67.5vh" margin="1vw 0 0 0" :loading="skeletonLoading">
        <AntEmpty v-show="!data.length" />
      </ElBlockSkeleton> -->

      <AntPolySkeleton height="3rem" :num="8" :rows="1" margin="0.3rem 0" :loading="skeletonLoading" />
      <!-- <AntPolySkeleton height="29.5rem" :loading="skeletonLoading"><AntEmpty v-show="!data.length" /></AntPolySkeleton> -->
      <swiper class="swiper" :options="option" :key="key" @mouseover.native="mouseover" @mouseout.native="mouseout">
        <swiper-slide :class="`swiper_slide`" v-for="(item,index) in data" :key="index">
          <div class="whole" @click="submit(item)">
            <div class="tag_title">
              <span class="tag">{{ t('home.currentStatus') }}</span>
              <span class="title">{{item.stdNo}}</span>
            </div>
            <div class="content">{{item.stdName}}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { t } from '@/locales';
let livingExample = null; //swiper实例
let that = null;
export default {
  data() {
    return {
      key: 0,
      skeletonLoading: true,
      data: [],
      option: {}
    }
  },
  created() {
    this.setOption();
    this.getData();
  },
  methods: {
    t,
    viewMore() {
      this.$FN.limitsTips({ list: ["home_renewalStandard_list"] }).then(res => {
        if (res) {
          this.$router.$push("/newStandardList")
          // this.$router.$push({ path: 'container', query: { url: `${this.$FN.iframeUrl}/npg/stdlatenew` } });
        }
      });
    },
    submit(data) {
      this.$FN.limitsTips({ list: ["home_renewalStandard_details"] }).then(res => {
        if (res) {
          this.$router.$push({
            path: "/detailsPage/standardDetail",
            query: {
              id: this.$FN.check(data, "id"),
              oneRoute: JSON.stringify({ backUrl: "/standard?mode=standardSearch_system_search", title: t('home.renewalTitle') })
            }
          })
          // this.$router.$push({ path: 'container', query: { url: `${this.$FN.iframeUrl}/npg/stdsearch/stdsearch_detail?sid=${data.id}` } });
        }
      });
    },
    mouseover() { livingExample.autoplay.stop() },
    mouseout() { livingExample.autoplay.start() },
    setOption() {
      this.option = {
        pagination: '.swiper-pagination',
        direction: "vertical",
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        slidesPerView: 8,
        initialSlide: 0,
        autoHeight: true,
        spend: 300,
        preventClicks: false,
        on: {
          init: function () { livingExample = this },
          slideChange: function () {
            // console.log(this.activeIndex, "this.activeIndex");
            // 由于this没有指向vue实例,所以需要activeIndex中转一下
            // that.activeIndex.index = this.activeIndex;
            // let { path = '' } = that.headerList[this.activeIndex];
            // if (path) that.form.moduleId = path;
            // that.getData();
          }
        }
      };
    },
    getData() {
      this.$FN.post("api/product_service/standard/stdList").then(res => {
        this.skeletonLoading = false;
        if (res) {
          let { entity = [] } = res;
          this.data = entity;
          this.key = Math.random();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>